module.exports = __webpack_public_path__ + "img/intro-yellow-shape.c02c0c71.svg";